import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listSpecialist: [],
  listNutricionist: [],
  listPsychologists: [],
  listPhysiotherapists: [],
  listCoaches: [],
};

const specialistSlice = createSlice({
  name: "sepcialists",
  initialState,
  reducers: {
    setListSpecialists: (state, action) => {
      state.listSpecialist = action.payload.listSpecialist;
      state.listCoaches =
        action.payload.listSpecialist.filter((user) => user.role === "Coach") ??
        [];
      state.listNutricionist = action.payload.listSpecialist.filter(
        (user) => user.role === "Nutricionist"
      );
      state.listPhysiotherapists = action.payload.listSpecialist.filter(
        (user) => user.role === "Physiotherapy"
      );
      state.listPsychologists = action.payload.listSpecialist.filter(
        (user) => user.role === "Psychologist"
      );
    },
    clearSpecialist: (state) => {
      state.listCoaches = [];
      state.listNutricionist = [];
      state.listPhysiotherapists = [];
      state.listPsychologists = [];
      state.listSpecialist = [];
    },
  },
});

export const { setListSpecialists, clearSpecialist } = specialistSlice.actions;
export default specialistSlice.reducer;
